/**
 * Utility functions for working with extended fields
 */

/**
 * Regular expression pattern for extended field identifiers
 * Format: {BusinessId}.Ext-{FieldName}-{Owner}-{FieldType}(-v{Version})?
 * Example: business123.Ext-CustomField-Owner-Text-v1
 */
const EXTENDED_FIELD_PATTERN = /^\w+\.Ext-(\w+)-(\w+)-(\w+)(-v(\d+))?$/;

/**
 * Determines if a form field identifier represents an extended field
 * @param identifier The field identifier to check
 * @returns true if the identifier matches the extended field pattern, false otherwise
 */
export function isExtendedField(
  identifier: string | null | undefined
): boolean {
  if (!identifier) {
    return false;
  }
  return EXTENDED_FIELD_PATTERN.test(identifier);
}
